import { LANG } from '../constants/config';

const loadMessages = (lang) => {
  return {
    en: require('./locales/en.json'),
    ru: require('./locales/ru.json'),
    tr: require('./locales/tr.json'),
  }[lang];
};

export default {
  locale: LANG,
  fallbackLocale: 'tr',
  messages: {
    [LANG]: loadMessages(LANG),
  },
};
